import {getFetchNonce} from '@github-ui/fetch-nonce'
import {forwardRef, type JSX} from 'react'
import {useClientValue} from '@github-ui/use-client-value'

export type IncludeFragmentProps = JSX.IntrinsicElements['include-fragment']

export const IncludeFragment = forwardRef<HTMLElement, IncludeFragmentProps>(function IncludeFragmentWithRef(
  {children, src, ...props},
  ref,
) {
  const [isSSR] = useClientValue(() => false, true, [])

  return (
    // eslint-disable-next-line react/forbid-elements
    <include-fragment {...props} ref={ref} {...(isSSR ? {} : {src, 'data-nonce': getFetchNonce()})}>
      {children}
    </include-fragment>
  )
})

try{ IncludeFragment.displayName ||= 'IncludeFragment' } catch {}